/**
 * GULP — Free Gift With Purchase
 * Automatically adds the GULP Bag when The Full Set bundle is in the cart.
 * The 100% discount is applied via a Shopify automatic Buy X Get Y discount in admin.
 *
 * SHOPIFY ADMIN SETUP (do once):
 * Discounts → Create discount → Buy X Get Y
 *   - Customer buys: "The Full Set" (the-full-set), qty 1
 *   - Customer gets: "GULP Bag" (gulp-bag), qty 1, 100% off
 *   - Set as Automatic discount (no code needed)
 */

(function () {
  var BUNDLE_HANDLE     = 'the-full-set';
  var GIFT_HANDLE       = 'gulp-bag';
  var GIFT_PROPERTY     = '_free_gift'; // hidden line item property to identify auto-added gift
  var syncing           = false;

  // Fetch the bag's variant ID once via the storefront product JSON
  function getGiftVariantId() {
    return fetch('/products/' + GIFT_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        return product.variants[0].id;
      });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function bundleInCart(cart) {
    return cart.items.some(function (item) {
      return item.handle === BUNDLE_HANDLE;
    });
  }

  function giftInCart(cart) {
    return cart.items.find(function (item) {
      return item.handle === GIFT_HANDLE &&
             item.properties &&
             item.properties[GIFT_PROPERTY] === 'true';
    });
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: 'true',
            'Free Gift': 'Complimentary with The Full Set'
          }
        }]
      })
    });
  }

  function removeGift(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function syncGift() {
    if (syncing) return;
    syncing = true;

    Promise.all([fetchCart(), getGiftVariantId()])
      .then(function (results) {
        var cart       = results[0];
        var variantId  = results[1];
        var hasBundle  = bundleInCart(cart);
        var giftItem   = giftInCart(cart);

        if (hasBundle && !giftItem) {
          return addGift(variantId).then(function () {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          });
        } else if (!hasBundle && giftItem) {
          return removeGift(giftItem.key).then(function () {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          });
        }
      })
      .catch(function (err) {
        console.error('[GULP GWP]', err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  // Run on page load (handles refresh/back-navigation)
  document.addEventListener('DOMContentLoaded', syncGift);

  // Run after any add-to-cart
  document.addEventListener('theme:cart:added', syncGift);

  // Run after cart drawer loads (covers qty changes and removals)
  document.addEventListener('theme:cart:loaded', syncGift);

})();
